module.exports = __webpack_public_path__ + "img/estrategicos.cbdfd951.svg";